import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_VENDOR: {
      // return { ...state, [action.value.id]: action.value };
      return { ...state, ...action.value };
    }
    case Action.REMOVE_ALL_VENDORS: {
      return {};
    }
    default:
      return state;
  }
};
